import * as React from 'react';
import Viewer from 'bpmn-js/lib/Viewer';
import 'bpmn-js/dist/assets/diagram-js.css';
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
import 'bpmn-js/dist/assets/bpmn-js.css';

import { useParams } from "react-router-dom";
import Service from '../../../util/Service';
import { Box, Button, Divider, Fab, IconButton, List, ListItemButton, ListItemText, Modal, Paper, Popover, SpeedDial, SpeedDialAction, SpeedDialIcon, Stack, Tooltip, Typography } from '@mui/material';
import { ArrowBack, BugReport, CancelScheduleSend, CleaningServices, Clear, MoreHoriz, PestControl, Replay } from '@mui/icons-material';

import { SnackbarsVy, formataDataHora, useInterval } from '../../../util/Utilitarios';
import diagramXML from '../../../resources/newDiagram.bpmn';
import "../BpmnPanel.css";
import AlertDialog from '../../util/AlertDialog';
import BGErroDebugPanel from './BGErroDebugPanel';
// var viewer = null;
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    minHeight: 200,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
};
export default function FlowProcessPanel() {
    const params = useParams();
    let bpmnPanel = React.useRef(null);
    const [processo, setProcesso] = React.useState();
    const [lista, setLista] = React.useState();
    const [processoBG, setProcessoBG] = React.useState();
    const [node, setNode] = React.useState();
    const [openModal, setOpenModal] = React.useState(false);
    const [trigger, setTriger] = React.useState(false);
    const [elapsedTime, setElapsedTime] = React.useState(0);
    const [tree, setTree] = React.useState({
        nome: 'Nome',
        descricao: 'Desck',
        root: {
            nome: 'Main'
        }
    });
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [viewer, setView] = React.useState();
    const [openSnack, setOpenSnack]= React.useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const openPopover = Boolean(anchorEl);
    const id = openPopover ? 'simple-popover' : undefined;

    React.useEffect(() => {
        buscaBG();
        buscaProcesso();
    }, [])
    React.useEffect(() => {
        console.log('>>viewer<<', viewer)
        if (viewer) {
            buscaGridFSFileById(processo.idBpmn);
            viewer.on('import.done', handleImporDone);
        }
    }, [viewer])

    React.useEffect(() => {
        clearPath();
        printPath();
        console.log(">>>>processoBG<<<<", processoBG)
        if (processoBG && processoBG.status === 'RUNNING') {
            if (!trigger) setTriger(true);
        }
    }, [processoBG]);
    React.useEffect(() => {
        if (processo) {
            if (!viewer) {
                const container = bpmnPanel.current;
                const v = new Viewer({
                    container,
                    // moddleExtensions: {
                    //     custom: customModdleExtension
                    // }
                });
                // v.on('import.done', handleImporDone);
                setView(v)
            }
        }
    }, [processo]);
    React.useEffect(() => {
        if (trigger) {
            buscaTempoExecucaoProcessoBG();
        }
    }, [trigger]);


    const handleClickPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };
    const handleClose = () => setOpenModal(false);
    function buscaBG() {
        Service.GET("/api/bpmn/buscaProcessoBGPorProcessoId/" + params.id).then(ret => {
            setLista(ret)
        });
    }
    
    useInterval(10000, ()=>{
        if( openModal )return;
        Service.GET("/api/bpmn/buscaProcessoBGPorProcessoId/" + params.id).then(ret => {
            // if( ret.length > lista.length ){
                // setLista(ret);
            // }
            setLista(ret);
            if( processoBG ){
                Service.GET("/api/bpmn/buscaProcessoBGPorId/" + processoBG.id).then(ret => {
                    if( ret.dtAtualizacao !== processoBG.dtAtualizacao){
                        setProcessoBG(ret);
                        // const arr = [...lista];
                        // let item = arr.find(a => a.id === ret.id);
                        // if( item) item = ret;
                        // setLista(arr);
                    }
                });
            }
        });
    })
    function buscaProcesso() {
        Service.GET("/api/bpmn/buscaProcessoPorId/" + params.id).then(ret => {
            setProcesso(ret);
        });
    }
    function buscaProcessoBG(id) {
        Service.GET("/api/bpmn/buscaProcessoBGPorId/" + id).then(ret => {
            setProcessoBG(ret);
        });
    }
    function hasListaErro() {
        if (processoBG && processoBG.lstErro) {
            return processoBG.lstErro.length > 0
        }
        return false;
    }
    function buscaGridFSFileById(id) {
        const url = "/api/bpmn/GridFSFileById/" + id;
        fetch(url, { headers: { Authorization: `Bearer ${localStorage.accessToken}` } })
            .then(function (response) {
                return response.text();
            })
            .then(function (text) {
                console.log(viewer)
                try {
                    viewer.importXML(text);
                } catch (err) {
                    console.error(err)
                }
            })["catch"](function (err) {
                console.error(">>>erro: ", err)
            });
    }
    function handleLimpaBackGround() {
        Service.GET("/api/security/backGround/removeBGByIdP/" + processo.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setElapsedTime(0);
            }
            buscaBG();
            handleClosePopover();
            handleClose();
        });
    }
    function handleLimpaListaErro() {
        Service.GET("/api/bpmn/processErroClean/" + processoBG.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setElapsedTime(0);
                buscaBG();
                setProcessoBG(ret.processoBG)
            }
            handleClosePopover();
            handleClose();
        });
    }
    const clearPath = () => {
        if (!processoBG) return;
        if (!viewer) return;
        const elementRegistry = viewer.get('elementRegistry');
        const elements = elementRegistry.getAll();
        var canvas = viewer.get('canvas');
        for (let x in elements) {
            const el = elements[x];
            const id = el.id;
            canvas.removeMarker(id, 'highlight');
        }
    }
    const printPath = () => {
        if (!processoBG) return;
        if (!viewer) return;
        const elementRegistry = viewer.get('elementRegistry');
        const elements = elementRegistry.getAll();
        var canvas = viewer.get('canvas');

        for (let x in elements) {
            const el = elements[x];
            const id = el.id;
            let done = verificaDone(el);
            if (done) {
                canvas.addMarker(id, 'highlight');
            }
        }
    }
    function buscaTempoExecucaoProcessoBG() {
        console.log('>>>buscaTempoExecucaoProcessoBG<<<')
        Service.GET("/api/bpmn/verTempoExecPBG/" + processoBG.id).then(ret => {
            setElapsedTime(ret.elapsedTime ? ret.elapsedTime : 0)
        });
    }
    const handleEvenBusEvent = (e) => {
        setNode(e.element);
        console.log(e.element)
        setOpenModal(true);
    }
    const handleImporDone = (event) => {
        var error = event.error,
            warnings = event.warnings;
        if (error) {
            console.error(error)
            return
        }
        if (!viewer) return;
        var eventBus = viewer.get('eventBus');
        var events = ['element.mouseup'];
        events.forEach(function (event) {
            eventBus.off(event);
            eventBus.on(event, handleEvenBusEvent);
        });
        viewer.get('canvas').zoom('fit-viewport');
    }
    function verificaDone(el) {
        // if (processoBG && processoBG.status === 'DONE') return true;
        if (el.type === "bpmn:StartEvent") return true;
        if (processoBG && processoBG.lstTask) {
            const item = processoBG.lstTask.find(t => t.idTask === el.id);
            if (!item) {
                if (processoBG && processoBG.status === 'DONE') {
                    if (el.type === "bpmn:ExclusiveGateway") return true;
                    if (el.type === "bpmn:EndEvent") return true;
                }

            }
            return item != null;
        }
        return false;
    }
    function handleOnDebug(){
        console.log('>>>handleOnDebug<<<<')
        const url = processoBG.onDebug?"/api/security/backGroundTask/debugOff/":"/api/security/backGroundTask/debugOn/"
        Service.GET(url + processoBG.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setOpenSnack(true);
                setMsg(processoBG.onDebug?"Degub is off":"Debug is on")
                buscaBG();
                buscaProcessoBG(processoBG.id);
                handleClose();
                handleClosePopover();
            }
        });
    }
    function handleReprocessar() {
        Service.GET("/api/bpmn/reprocessar/" + processoBG.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setProcessoBG(ret.processoBG)
            }
        });
    }
    function handleToobleDebugProcesso(){
        console.log(processo);
        Service.GET('/api/security/processoToogleDebug/'+processo.id).then(r => {
            console.log(r);
            if (r.success) {
                buscaProcesso();
                handleClose();
            }
        })
    }
    function handleRemoverItem(node) {
        const dado = {
            idTask: node.id,
            idBG: processoBG.id
        }
        console.log(dado);
        Service.POST('/api/security/backGroundTask/apagarTask', dado).then(r => {
            console.log(r);
            if (r.success) {
                buscaProcessoBG(processoBG.id);
                handleClose();
            }
        })
    }
    function hasErroCode() {
        if (processoBG) {
            if (processoBG.status === 'ERRO_CODIGO') return true
        }
        return false;
    }
    function hasErro() {
        if (processoBG) {
            if (processoBG.status === 'ERROR') return true
        }
        return false;
    }
    function hasRunnitg() {
        if (processoBG) {
            if (processoBG.status === 'RUNNING') {
                return true
            }
        }
        return false;
    }
    function handleStop() {
        Service.GET("/api/bpmn/stopProcess/" + processoBG.id).then(ret => {
            if (!ret.success) {
                setOpen(true);
                setMsg(ret.msg);
            } else {
                setElapsedTime(0);
                setProcessoBG(ret.processoBG)
            }
        });
    }
    function handleFluxoCodigoQuebrado() {
        setMsg("Fluxo de report de erro de codigo não implementado");
        setOpen(true);
    }
    function handleUpdate(bg){
        buscaBG();
        buscaProcessoBG(bg.id);
    }
    const MontaTempoDecorrido = () => {
        let tempo = elapsedTime / 1000;
        let mask = 'segundos';
        if (tempo > 60) {
            tempo = tempo / 60;
            mask = 'minutos';
            if (tempo > 60) {
                tempo = tempo / 60;
                mask = 'horas';
                if (tempo > 24) {
                    tempo = tempo / 24;
                    mask = 'dias';
                }
            }
        }
        return (
            <div >
                <Typography>{"Processo executando em " + Math.floor(tempo) + " " + mask}</Typography>
            </div>
        )
    }
    function handleUpdate(bg){
        console.log('>>>???<<<')
    }
    const MontaNodeInfo = () => {
        const item = (processoBG && node) ? processoBG.lstTask.filter(t => t.idTask === node.id) : null;
        if (node && node.type.indexOf("Gateway") > 0) {
            console.log(node.id);
            console.log(processo);
            const flow = processo.lstTask.find(t => t.idTask === node.id)
            if (flow) {
                return (
                    <ul>
                        {Object.keys(flow.criterio).map((row, i) => (
                            <li style={{ marginBottom: '10px' }} key={i}>{row + ": " + flow.criterio[row]}</li>
                        )
                        )}
                    </ul>
                )
            } else
                return (
                    <p>Gateway não definido</p>
                )
        }
        const formatted = (item && item.length > 0) ? JSON.stringify(item[item.length - 1], null, 2) : null;
        return (
            <>
                {(item && item.length > 0) ? (
                    <pre style={{
                        backgroundColor: '#1e1e1e',
                        color: '#d4d4d4',
                        padding: '15px',
                        borderRadius: '5px',
                        fontSize: '14px',
                        wordBreak: 'break-word',
                        overflow: 'auto',
                        lineHeight: '1.5',
                        maxWidth: '900px',
                        maxHeight: '520px'
                    }}>
                        <span style={{ color: '#ce9178' }}>{formatted}</span>
                    </pre>
                ) : (
                    <Typography variant="body2" color="textSecondary">
                        Nenhuma informação disponível.
                    </Typography>
                )}
            </>
        );
    };
    const PrintErro = () => {
        if (processoBG && processoBG.lstErro && processoBG.lstErro.length > 0) {
            return (
                <Paper elevation={0} sx={{ border: '1px solid black', borderRadius: '8px', padding: '8px', width: '100%' }}>
                    <Stack>
                        {processoBG.lstErro.map((e, i) => (
                            <Typography key={i}>{(i + 1) + " -> " + e}</Typography>
                        ))}
                    </Stack>

                </Paper>
            )
        }
        return (
            <div />
        )
    }

    return (
        <Paper>
            {processoBG &&
                <Fab sx={{ 
                    position: 'absolute', 
                    right: 12,  
                    bgcolor: (processoBG && processoBG.onDebug)?'red':''
                }} color="primary" size="small" aria-label="add" onClick={handleClickPopover}>
                    <MoreHoriz />
                </Fab>}
            <Stack direction="row" spacing={2}>
                
                <List dense={true} sx={{ 
                    width: '100%', 
                    maxWidth: 260, 
                    maxHeight:'90vh', 
                    bgcolor: 'background.paper',
                    position: 'relative',
                    overflow: 'auto',
                    }}>
                    {lista && lista.map((row) => (
                        <ListItemButton alignItems="flex-start" key={row.id} onClick={() => setProcessoBG(row)}
                            sx={row.onDebug?{border:'2px solid orange', bgcolor: (processoBG && row.id=== processoBG.id)?'primary.light':'background.paper'}
                                           :{bgcolor: (processoBG && row.id=== processoBG.id)?'primary.light':'background.paper'}}
                        >
                            <ListItemText
                                primary={formataDataHora(row.dtCriacao)}
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{ color: 'text.primary', display: 'inline' }}
                                        >
                                            {"Tasks: " + (row.lstTask ? row.lstTask.length : 0)}
                                        </Typography>
                                        {" — Status: " + row.status}
                                    </React.Fragment>
                                }
                            />
                        </ListItemButton>
                    ))}
                </List>

                <div ref={bpmnPanel}
                    style={{
                        height: 400,
                        width: '100%',
                        border: '1px solid #333',
                        borderRadius: '7px',
                        padding: '8px',

                    }}
                />
            </Stack>
            
            <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {/* <Box sx={{ border: "1px solid var(--pd-primary-dark)", display: "flex", justifyContent: 'flex-end' }}> */}
                <Stack spacing={1}>
                    <Tooltip title={processoBG && processoBG.onDebug?"Debug-OFF":"Debug-ON"}>
                        <IconButton aria-label="reprocessar" color="inherit" onClick={handleOnDebug}>
                            <PestControl />
                        </IconButton>
                    </Tooltip>
                    {hasErro() &&
                        <Tooltip title="Executar novamente">
                            <IconButton aria-label="reprocessar" color="inherit" onClick={handleReprocessar}>
                                <Replay />
                            </IconButton>
                        </Tooltip>
                    }
                    {hasErroCode() &&
                        <Tooltip title="Reportar erro de codigo">
                            <IconButton aria-label="report" color="primary" onClick={handleFluxoCodigoQuebrado}>
                                <BugReport />
                            </IconButton>
                        </Tooltip>}
                    {hasRunnitg() &&
                        <Tooltip title="Parar execução do codigo">
                            <IconButton aria-label="stop" color="primary" onClick={handleStop}>
                                <CancelScheduleSend />
                            </IconButton>
                        </Tooltip>}
                    {hasListaErro() &&
                        <Tooltip title="Limpar lista de erro">
                            <IconButton aria-label="stop" color="primary" onClick={handleLimpaListaErro}>
                                <CleaningServices />
                            </IconButton>
                        </Tooltip>}
                        <Divider/>
                        <Tooltip title="Remove todas execuções em BackGround">
                            <IconButton aria-label="stop" color="primary" onClick={handleLimpaBackGround}>
                                <Clear />
                            </IconButton>
                        </Tooltip>
                    {elapsedTime > 0 && <MontaTempoDecorrido />}
                </Stack>
                <SnackbarsVy open={openSnack} setOpen={setOpenSnack} severity="success" msg={msg}/>
            </Popover>
            <PrintErro />
            <BGErroDebugPanel processoBG={processoBG} update={handleUpdate} />
            <AlertDialog open={open} setOpen={setOpen} msg={msg} title="Alerta" />
            <Modal
                open={openModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack direction="row" spacing={5}>
                        <Typography id="modal-modal-title" variant="h5" sx={{ fontWeight: 'bold' }}>
                            {node && node.di.bpmnElement.name}
                        </Typography>
                        {node && node.type.indexOf("Gateway") < 0 &&
                            <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => handleRemoverItem(node.di.bpmnElement)} >
                                Voltar Fluxo
                            </Button>}
                        {node && node.type === 'bpmn:Process' &&
                            <Tooltip title={processo.onDebug?"Desligar debug":"Ligar debug"}>
                                <Button variant="outlined" startIcon={<BugReport />} onClick={handleToobleDebugProcesso} >
                                    Debug {processo.onDebug?"OFF":"ON"}
                                </Button>
                            </Tooltip>
                        }
                    </Stack>

                    {/* Tipo do Node */}
                    <Typography variant="body1" sx={{ marginBottom: 3 }}>
                        <strong>Tipo:</strong> {node && node.type}
                    </Typography>

                    <MontaNodeInfo id="modal-modal-description" />

                </Box>
            </Modal>
        </Paper>
    )
}